export const endpoints = {
  admin: {
    auth: {
      login: "/admin/auth/login",
      logout: "/admin/auth/logout",
      me: "/admin/auth/me",
    },
    admins: "/admin/admins",
    adminById: (id: string) => `/admin/admins/${id}`,
    adminPassword: (id: string) => `/admin/admins/${id}/password`,
    profile: "/admin/profile",
    profilePassword: "/admin/profile/password",
    themes: "/admin/themes",
    themeById: (id: string) => `/admin/themes/${id}`,
    themeVersions: (id: string) => `/admin/themes/${id}/versions`,
    themeVersion: (id: string, versionId: string) =>
      `/admin/themes/${id}/versions/${versionId}`,
    themeVersionMeta: (id: string, versionId: string) =>
      `/admin/themes/${id}/versions/${versionId}/meta`,
    themeVersionPublish: (id: string, versionId: string) =>
      `/admin/themes/${id}/versions/${versionId}/publish`,
    // Served by `AdminThemePreviewController`, which lives in the SELLER module
    // (it needs StoreRepository + PreviewTokenService, and moving those the
    // other way would close a dependency cycle). The path keeps it grouped with
    // the rest of the admin theme API for clients.
    themeVersionPreviewToken: (id: string, versionId: string) =>
      `/admin/themes/${id}/versions/${versionId}/preview-token`,
    sellers: "/admin/sellers",
    sellerOptions: "/admin/sellers/options",
    sellerById: (id: string) => `/admin/sellers/${id}`,
    sellerStores: (id: string) => `/admin/sellers/${id}/stores`,
    sellerInvite: (id: string) => `/admin/sellers/${id}/invite`,
    stores: "/admin/stores",
    storeOptions: "/admin/stores/options",
    storeById: (id: string) => `/admin/stores/${id}`,
    storeStats: (id: string) => `/admin/stores/${id}/stats`,
    storeImpersonationSession: (id: string) =>
      `/admin/stores/${id}/impersonation-session`,
    storeOrders: (storeId: string) => `/admin/stores/${storeId}/orders`,
    storeOrderStatusCounts: (storeId: string) =>
      `/admin/stores/${storeId}/orders/status-counts`,
    storeOrderById: (storeId: string, orderId: string) =>
      `/admin/stores/${storeId}/orders/${orderId}`,
    storeOrderStatus: (storeId: string, orderId: string) =>
      `/admin/stores/${storeId}/orders/${orderId}/status`,
    storeOrderProof: (storeId: string, orderId: string) =>
      `/admin/stores/${storeId}/orders/${orderId}/proof`,
    storeOrderPaymentTransaction: (storeId: string, orderId: string) =>
      `/admin/stores/${storeId}/orders/${orderId}/payment-transaction`,
    storeOrderRefund: (storeId: string, orderId: string) =>
      `/admin/stores/${storeId}/orders/${orderId}/refund`,
    storeOrderReviewApprove: (storeId: string, orderId: string) =>
      `/admin/stores/${storeId}/orders/${orderId}/payment-review/approve`,
    storeOrderReviewReject: (storeId: string, orderId: string) =>
      `/admin/stores/${storeId}/orders/${orderId}/payment-review/reject`,
    subscriptions: "/admin/subscriptions",
    subscriptionById: (id: string) => `/admin/subscriptions/${id}`,
    storeSubscriptions: "/admin/stores/subscriptions",
    storeSubscriptionAssignments: (id: string) =>
      `/admin/stores/${id}/subscriptions`,
    storeSubscriptionPayments: (id: string) =>
      `/admin/stores/${id}/subscription-payments`,
    storeSubscriptionScheduleCurrent: (id: string) =>
      `/admin/stores/${id}/subscription-schedule/current`,
    storeSubscriptionScheduleLedger: (id: string) =>
      `/admin/stores/${id}/subscription-schedule-ledger`,
    storeSubscriptionPaymentById: (storeId: string, paymentId: string) =>
      `/admin/stores/${storeId}/subscription-payments/${paymentId}`,
    storeSubscriptionPaymentProofUrl: (storeId: string, paymentId: string) =>
      `/admin/stores/${storeId}/subscription-payments/${paymentId}/proof-url`,
    storeSubscriptionPaymentRestore: (storeId: string, paymentId: string) =>
      `/admin/stores/${storeId}/subscription-payments/${paymentId}/restore`,
    subscriptionPaymentProofUploads: "/admin/uploads/subscription-payments",
    themeThumbnailUploads: "/admin/uploads/theme-thumbnails",
    fcmTokens: "/admin/fcm-tokens",
    appConfigs: "/admin/app-configs",
    appConfigByKey: (key: string) =>
      `/admin/app-configs/${encodeURIComponent(key)}`,
    appConfigAudit: (key: string) =>
      `/admin/app-configs/${encodeURIComponent(key)}/audit`,
    featureFlags: "/admin/feature-flags",
    featureFlagById: (id: string) => `/admin/feature-flags/${id}`,
    featureFlagAudit: (id: string) => `/admin/feature-flags/${id}/audit`,
    areas: "/admin/areas",
    areaById: (id: string) => `/admin/areas/${id}`,
    areaGovernorates: "/admin/areas/governorates",
    areaSuggestions: "/admin/area-suggestions",
    areaSuggestionApprove: (id: string) =>
      `/admin/area-suggestions/${id}/approve`,
    areaSuggestionReject: (id: string) =>
      `/admin/area-suggestions/${id}/reject`,
    integrationLogs: "/admin/integration-logs",
    integrationLogById: (id: string) => `/admin/integration-logs/${id}`,
  },
} as const;
